const TOPICS = [
  'TED-Ed',
  'Psychology',
  'Leadership',
  'Education',
  'AI',
  'Sleep',
  'Mental health',
  'Business',
  'Motivation',
  'Communication',
  'Personal growth',
  'Sports',
  'Health',
  'Language'
];

const CONTENT = {
  homepageTitle: 'Powerful ideas. Powerfully presented.',
  defaultPageTitle: 'TED Talks: Discover ideas worth spreading',
  defaultPageTitleBottom: `Didn't find what you like? Start a search.`,
  resultsPageTitle: `Didn't find what you like? Start a new search.`
};

export const TOPICS_LAUNCH_PAD_CONSTANTS = {
  TOPICS,
  CONTENT
} as const;
